function parseProblemSolvingForReplication(data) {
  const {
    categories = [],
    location = {},
    name,
    priority,
    problemAnalysis = {},
    problemBreakdown,
    processGaps,
    rootCauses = [],
    solutionDescription,
  } = data

  return {
    categories,
    location,
    name,
    priority,
    problemAnalysis: {
      businessRequirements: problemAnalysis?.businessRequirements ?? '',
      containment: problemAnalysis?.containment ?? '',
      goals: problemAnalysis?.goals ?? '',
      measureDescription: problemAnalysis?.measureDescription ?? '',
      problem: problemAnalysis?.problem ?? '',
    },
    problemBreakdown,
    processGaps,
    replicatedFromRevId: data?.replicatedFromRevId,
    rootCauses: rootCauses.map((rootCause, index) => ({
      name: rootCause?.name ?? '',
      type: rootCause?.type ?? null,
      description: rootCause?.description ?? '',
      correctiveAction: rootCause?.correctiveAction ?? '',
      correctiveActionWorked: rootCause?.correctiveActionWorked,
      correctiveLearning: rootCause?.correctiveLearning,
      preventiveAction: rootCause?.preventiveAction ?? '',
      position: index,
      analysisWhyBreakdown: rootCause?.analysisWhyBreakdown ?? [],
    })),
    solutionDescription,
  }
}

function parseQuickActionForReplication(data) {
  const {
    afterPhase = {},
    beforePhase = {},
    categories = [],
    location = {},
    name,
    priority,
  } = data

  return {
    name,
    categories,
    location,
    beforePhase: {
      situation: beforePhase?.situation || '',
      situationTypes: beforePhase?.situationTypes || [],
    },
    afterPhase: {
      solution: afterPhase?.solution || '',
      suggestedTags: afterPhase?.suggestedTags || [],
    },
    priority,
    replicatedFromRevId: data?.replicatedFromRevId,
  }
}

function parseImprovementIdeaForReplication(data) {
  const relate = data.relate || {}
  const experiment = data.experiment || {}
  const verify = data.verify || {}
  const expand = data.expand || {}
  const location = data.location || {}

  return {
    name: data.name,
    cycle: {
      expandLearn: verify.learned,
      expandSustain: expand.solution,
      experimentDone: experiment.whatDidYouDo,
      relateIdea: relate.idea,
      relateProblem: relate.problem,
      relateResult: relate.expectedResult,
      verify: verify.didExperimentWork,
      reviewNotImplementedExplanation: expand.whyNotImplemented,
    },
    categories: data.categories,
    attributes: location.attributes,
    tags: location.tags,
    priority: data.priority,
    replicatedFromRevId: data?.replicatedFromRevId,
  }
}

export default function parseRevDataForReplication(type, data) {
  switch (type) {
    case 'problemSolving':
      return parseProblemSolvingForReplication(data)
    case 'quickAction':
      return parseQuickActionForReplication(data)
    case 'improvementIdea':
      return parseImprovementIdeaForReplication(data)
    default:
      throw new Error(`Unknown rev type: ${type}`)
  }
}
